<div class="dashboard-name">
	<i class="fa-solid fa-chart-line"></i>
	<span>EforAll Data Dashboards</span>
</div>

<div class="right-side">

	<button class="btn toolbar-btn">
		<i class="fa-regular fa-plus" (click)="pageService.toggleQuickFilters()"></i>
	</button>

	<button class="btn toolbar-btn">
		<i class="fa-regular fa-filter" (click)="pageService.toggleQuickFiltersPanel()"></i>
	</button>

	<button #menuBtn class="btn toolbar-btn" (click)="toggleMenu()">
		<i class="fa-regular fa-bars"></i>
	</button>

	@if (isMenuOpen()) {
	<ul #menu class="dropdown-menu">
		<li (click)="openDialog('Settings')"><i class="fa-regular fa-gear"></i>Dashboard Settings</li>
		<li (click)="openDialog('Filters')"><i class="fa-regular fa-filter"></i>Dashboard Filters</li>
		<li (click)="openDialog('Vega Charts')"><i class="fa-regular fa-chart-column"></i>Vega Charts</li>
		<li (click)="openDialog('Vega Layouts')"><i class="fa-regular fa-grid"></i>Chart Layouts</li>
		<li class="menu-separator"><i class="fa-regular fa-clone"></i>Make a Copy</li>
		<li (click)="renderModeClick()" class="{{renderModeMenuClass()}}"><i class="{{renderModeClass()}}"></i>High Resolution</li>
		<li (click)="printPage()" class="{{printerMenuClass()}}"><i class="fa-regular fa-print"></i>Print</li>
		<li (click)="signOut()" class="sign-out menu-separator"><i class="fa-regular fa-power-off"></i>Sign Out</li>
	</ul>
	}
</div>